module.exports = __webpack_public_path__ + "img/omega-2-procedimental.dfcbdd47.png";